// extracted by mini-css-extract-plugin
module.exports = {"mid":"feature-module--mid--1QFtD","top":"feature-module--top--1WStN","bottom":"feature-module--bottom--2k-04","image_width":"feature-module--image_width--3Hifm"};